import { Box, styled } from "@mui/material";
import { ContentWrapperStylesProps } from "./ContentWrapper.props";

export const ContentWrapperStyles = styled(
  (props: ContentWrapperStylesProps) => <Box {...props} />,
  {
    shouldForwardProp: (prop) => prop !== "autoWidth" && prop !== "customSideMargin"
  }
)(
  ({ theme: { breakpoints }, autoWidth, customSideMargin }) => `
    &.MuiBox-root {
      margin: 0 ${customSideMargin?.mobile ?? 20}px;
      padding: 80px 0 65px;

      ${[breakpoints.up("sm")]} {
        margin: 0 auto;
        width: ${autoWidth ? "auto" : "500px"};
      }

      ${[breakpoints.up("md")]} {
        margin: 0 ${customSideMargin?.tablet ? `${customSideMargin.tablet}px` : "auto"};
        width: ${autoWidth ? "auto" : "800px"};
      }

      ${[breakpoints.up("xl")]} { 
        margin: 0 ${customSideMargin?.desktop ? `${customSideMargin.desktop}px` : "auto"};
        width: ${autoWidth ? "auto" : "950px"};
      }
    }
  `
);
